import { Col, FormGroup, Label, Row } from "reactstrap";
import SelectWithInput from "../../../Common/SelectWithInput";
import CheckboxCollapse from "../../../Common/CheckboxCollapse";
import { AvField, AvInput } from "availity-reactstrap-validation";
import CustomSelect from "../../../Common/CustomSelect";
import { getDefaultValueForSelect } from "../../../../helpers/utils";
import React from "react";
import PropTypes from "prop-types";
import FormByKpiIndicators from "./FormByKpiIndicators";

const FormByCostCPA = ({
  isLoading,
  offer_data,
  isFormSubmit,
  cost,
  trackers,
  events,
  suffix,
  offer,
  setGroups,
}) => {
  const [kpiIndicator, setKpiIndicator] = React.useState(
    cost?.cpa__kpi_indicator
  );
  const [isKpiIndicator, setIsKpiIndicator] = React.useState(
    !!cost?.cpa__kpi_indicator
  );

  const kpi_indicator_options = [
    { label: "Revenue", value: "Revenue" },
    { label: "Event %", value: "Event_%" },
    { label: "Retention", value: "Retention" },
    { label: "CPI", value: "CPI" },
    { label: "Average order value", value: "AOV" },
  ];

  const currency_type_options = [
    { label: "Avg per month", value: "Avg_per_month" },
    { label: "Last date", value: "Last_date" },
  ];

  const [isCustom, setIsCustom] = React.useState(false);

  const handleChangeKPI = val => {
    setKpiIndicator(val.value);
    setGroups(prev => {
      return prev.map(i => {
        if (`|${i.suffix}|` !== suffix) return i;

        return {
          ...i,
          suffix: Math.round(Math.random() * 10000).toString(),
          cpa__kpi_indicator: val.value,
        };
      });
    });
  };

  return (
    <React.Fragment>
      <Row>
        <Col md={6}>
          <FormGroup className="mb-3">
            <Label htmlFor="">CPA cost:</Label>
            <SelectWithInput
              select_name={"cpa__cost_currency" + suffix}
              options={offer_data.currencies}
              defaultValue={{
                label: cost?.cpa__cost_currency || "USD",
                value: cost?.cpa__cost_currency || "USD",
              }}
              required
              isLoading={isLoading}
              inputOptions={{
                name: "cpa__cost" + suffix,
                placeholder: "CPA cost",
                value: cost?.cpa__cost || "",
                type: "number",
                errorMessage: "CPA cost field is required!",
                validate: { required: { value: true } },
              }}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup className="mb-3">
            <CheckboxCollapse
              id={"cpa__cohort-days-id" + suffix}
              title="Cohort days"
              defaultChecked={!!cost?.cpa__is_cohort}
            >
              <AvField
                name={"cpa__cohort_days_quantity" + suffix}
                placeholder="Cohort days"
                type="number"
                value={cost?.cpa__cohort_days_quantity || ""}
                className="form-control"
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Please, enter a cohort days",
                  },
                  min: {
                    value: 0,
                    errorMessage: "The cohort cannot be negative",
                  },
                }}
              />
            </CheckboxCollapse>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup className="mb-3">
            <Label htmlFor="">
              Event{" "}
              <span
                className="btn__add-custom-event"
                onClick={() => setIsCustom(prev => !prev)}
              >
                ({!isCustom ? "Add custom event" : "View events"})
              </span>
              :
            </Label>
            {!isCustom ? (
              <CustomSelect
                name={"cpa__events" + suffix}
                options={events}
                placeholder="Select event..."
                classNamePrefix="select2-selection"
                errorMessage="Event field is required!"
                defaultValue={getDefaultValueForSelect(cost?.cpa__events)}
                isMulti
                isLoading={isLoading}
                isFormSubmit={isFormSubmit}
              />
            ) : (
              <CustomSelect
                name={"custom_event_names" + suffix}
                placeholder="Event name..."
                classNamePrefix="select2-selection"
                errorMessage="Event name field is required!"
                isMulti
                creatable
                required
                isFormSubmit={isFormSubmit}
              />
            )}
            {/* 
            <AvField
                name={"custom_event_name" + suffix}
                placeholder="Event name..."
                type="text"
                errorMessage="Event name field is required!"
                className="form-control"
                validate={{
                  required: { value: true },
                }}
              /> */}
          </FormGroup>
        </Col>
        {isCustom && (
          <Col md={3}>
            <FormGroup className="mb-3">
              {isCustom && (
                <>
                  <Label htmlFor="">Tracker</Label>
                  <CustomSelect
                    name={"custom_event_tracker" + suffix}
                    options={trackers}
                    defaultValue={trackers[0]}
                    placeholder="Select tracker..."
                    classNamePrefix="select2-selection"
                    errorMessage="Tracker field is required!"
                    required
                    isLoading={isLoading}
                    isFormSubmit={isFormSubmit}
                  />
                </>
              )}
            </FormGroup>
          </Col>
        )}
        <Col md={3}>
          <FormGroup className="mb-3">
            <AvInput
              className={"mr-1"}
              style={{ marginBottom: "10.5px" }}
              type="checkbox"
              name={"unique_events" + suffix}
              value={!!cost?.[`unique_events`] || false}
            />
            <Label check for={"unique_events" + suffix}>
              Is unique
            </Label>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <FormGroup className="mb-3">
            <Label htmlFor="">Currency type:</Label>
            <CustomSelect
              name={"currency_type"}
              options={currency_type_options}
              defaultValue={
                getDefaultValueForSelect(offer?.currency_type) ||
                currency_type_options[0]
              }
              placeholder="Currency type..."
              classNamePrefix="select2-selection"
              errorMessage="Currency type field is required"
              required
              isLoading={isLoading}
              isFormSubmit={isFormSubmit}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <FormGroup className="mb-3">
            <CheckboxCollapse
              id={"cpa__kpi-indicator-checkbox" + suffix}
              title="KPI indicator"
              defaultChecked={!!cost?.cpa__kpi_indicator}
              onChange={val => setIsKpiIndicator(val)}
            >
              <CustomSelect
                name={"cpa__kpi_indicator" + suffix}
                options={kpi_indicator_options}
                defaultValue={getDefaultValueForSelect(
                  cost?.cpa__kpi_indicator
                )}
                placeholder="Select KPI indicator..."
                classNamePrefix="select2-selection"
                errorMessage="KPI indicator field is required"
                onChange={handleChangeKPI}
                required
                isLoading={isLoading}
                isFormSubmit={isFormSubmit}
              />
            </CheckboxCollapse>
          </FormGroup>
        </Col>
        <Col md="6">
          {isKpiIndicator && (
            <FormGroup className="mb-3">
              <CheckboxCollapse
                id={"cohort-days-id" + suffix}
                title="Cohort days"
                defaultChecked={!!cost?.cpa__kpi_is_cohort}
              >
                <AvField
                  name={"cpa__kpi_cohort_days_quantity" + suffix}
                  placeholder="Cohort days"
                  type="number"
                  value={cost?.cpa__kpi_cohort_days_quantity || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a cohort days",
                    },
                    min: {
                      value: 0,
                      errorMessage: "The cohort cannot be negative",
                    },
                  }}
                />
              </CheckboxCollapse>
            </FormGroup>
          )}
        </Col>
      </Row>

      {isKpiIndicator && (
        <FormByKpiIndicators
          kpiIndicator={kpiIndicator}
          cost={cost}
          suffix={suffix}
          prefix="cpa"
          isLoading={isLoading}
          isFormSubmit={isFormSubmit}
        />
      )}
    </React.Fragment>
  );
};

FormByCostCPA.propTypes = {
  isLoading: PropTypes.any,
  offer_data: PropTypes.any,
  isFormSubmit: PropTypes.any,
  cost: PropTypes.any,
  trackers: PropTypes.any,
  events: PropTypes.any,
  suffix: PropTypes.string,
  setGroups: PropTypes.func,
  offer: PropTypes.any,
};

export default FormByCostCPA;
